/** biome-ignore-all lint/correctness/useExhaustiveDependencies: <explanation> */
import { useEffect, useState } from 'react'
import { useWatch } from 'react-hook-form'
import { matchCourseSchema } from '@/schemas/education/match-courses-schema'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { ButtonOptions, type ButtonOptionsItems } from '../button-options'

interface RequestActionButton {
  requestId: string
  grantActive: boolean
  denyActive: boolean
  buttonDisabled?: boolean
  grantAction?: (validform?: boolean) => void
  denyAction?: () => void
  formMethods?: StudentRequestedCoursesFormMethods
}

export const RequestActionButton = ({
  grantActive,
  denyActive,
  buttonDisabled,
  formMethods,
  grantAction,
  denyAction
}: RequestActionButton) => {
  const [validForm, setValidForm] = useState(false)

  const watched = useWatch({
    control: formMethods?.control
  })

  const handleValidForm = async () => {
    const validateFields = matchCourseSchema.pick({
      courseEquivalences: true,
      serie: true
    })
    const values = formMethods?.getValues?.()
    const isValid = validateFields.safeParse(values).success
    setValidForm(isValid)
  }

  useEffect(() => {
    handleValidForm()
  }, [watched])

  const buttons: ButtonOptionsItems[] = [
    {
      label: 'Deferir',
      textColor: 'text-[var(--brand-green)]',
      action: () => grantAction?.(validForm),
      active: grantActive,
      state: grantAction ? (validForm ? 'enabled' : 'blocked') : 'disabled'
    },
    {
      label: 'Indeferir',
      textColor: 'text-destructive',
      action: denyAction,
      active: denyActive
    }
  ]

  return (
    <ButtonOptions disabled={buttonDisabled} label="Ações" items={buttons} />
  )
}
